import { userRoles } from "core/constants"

export const getRoleName = (roleId: number) => {
    return userRoles[roleId];
}